import type { I18nKey } from '@pos/i18n';
import { Route } from 'react-router';
import type { NavGroup, NavItem } from './AdminShell';
import { ListScreen } from './ListScreen';
import { ResourceDetailPage } from './ResourceDetailPage';
import type { ResourceDef, ResourceMap } from './resources';

/** Side nav groups from the generated navigation: one link per top-level resource, gated by its read permission. */
export function resourceNav(
  resources: ResourceMap,
  groups: readonly { group: string; label: I18nKey; items: readonly string[] }[],
  icons: Readonly<Record<string, NavGroup['icon']>> = {},
): NavItem[] {
  return groups.map((group) => ({
    label: group.label,
    icon: icons[group.group],
    items: group.items
      .map((key) => resources[key])
      .filter((def): def is ResourceDef & { route: string } => Boolean(def?.route))
      .map((def) => ({ label: def.title, path: def.route, permission: def.readPermission })),
  }));
}

/** Routes for every top-level resource list, plus the shared record page. Use inside <Routes>. */
export function resourceRoutes(resources: ResourceMap) {
  return [
    ...Object.values(resources)
      .filter((def) => def.route)
      .map((def) => <Route key={def.key} path={def.route} element={<ListScreen def={def} />} />),
    <Route key="records" path="/records/:resource/:id" element={<ResourceDetailPage />} />,
  ];
}
